import { render, staticRenderFns } from "./StaticHouse.vue?vue&type=template&id=78472bee&scoped=true"
import script from "./StaticHouse.vue?vue&type=script&lang=js"
export * from "./StaticHouse.vue?vue&type=script&lang=js"
import style0 from "./StaticHouse.vue?vue&type=style&index=0&id=78472bee&prod&lang=css"
import style1 from "./StaticHouse.vue?vue&type=style&index=1&id=78472bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78472bee",
  null
  
)

export default component.exports